export type TimerCardKind = 'disabled' | 'play' | 'stop';

export interface TimerOption {
  id: string;
  primary: string;
  secondary?: string;
}

export const TIMER_PANEL_OPEN_EVENT = 'dt-pm:timer-panel-open';

export interface TimerPanelOpenDetail {
  anchorRect?: {
    right: number;
    bottom: number;
  };
}

export function requestTimerPanelOpen(anchor: Element): void {
  const rect = anchor.getBoundingClientRect();
  window.dispatchEvent(
    new CustomEvent<TimerPanelOpenDetail>(TIMER_PANEL_OPEN_EVENT, {
      detail: {
        anchorRect: {
          right: rect.right,
          bottom: rect.bottom,
        },
      },
    }),
  );
}

function normalizeSearch(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

/** Busca do dropdown do cronômetro: título ou texto secundário, sem diferenciar caixa e acentos. */
export function filterTimerOptions<T extends TimerOption>(options: readonly T[], term: string): T[] {
  const query = normalizeSearch(term);
  if (!query) return [...options];
  return options.filter((option) =>
    normalizeSearch(`${option.primary} ${option.secondary ?? ''}`).includes(query),
  );
}

export function formatTimerHMS(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) ? Math.max(0, Math.floor(totalSeconds)) : 0;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  const pad = (value: number): string => value.toString().padStart(2, '0');
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function resolveTimerCardKind(canStart: boolean, isRunning: boolean): TimerCardKind {
  if (isRunning) return 'stop';
  if (canStart) return 'play';
  return 'disabled';
}

export function placeBesideClock(
  clock: { right: number; bottom: number },
  panel: { width: number; height: number },
  viewport: { width: number; height: number },
): { top: number; left: number } {
  const gap = 12;
  const margin = 16;
  let left = clock.right + gap;
  let top = clock.bottom - panel.height;
  if (top < margin) top = margin;
  if (top + panel.height > viewport.height - margin) {
    top = Math.max(margin, viewport.height - margin - panel.height);
  }
  if (left + panel.width > viewport.width - margin) {
    left = Math.max(margin, viewport.width - margin - panel.width);
  }
  return { top, left };
}
